import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as FacebookIcon } from "../../assets/Icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../assets/Icons/twitter.svg";
import { ReactComponent as Closeicon } from "../../assets/Icons/closeFilled.svg";
import { ReactComponent as AddRatings } from "../../assets/Icons/starRounded.svg";
import { ReactComponent as StarIcon } from "../../assets/Icons/star.svg";
import * as service from "./service";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import "react-toastify/dist/ReactToastify.css";
import { authenticate2, getPlayerToken, getUserSubscription, updateWatchlistData } from "../../network/service";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import ShowsRow from "../../Components/ShowsRow/ShowsRow";
import { toast } from "react-toastify";
import WatchWithoutAdsModal from "../../Components/Modals/WatchWithoutAdsModal";
import LogoutAllModal from "../../Components/Modals/LogoutAllModal";
import { convertAdUrl, imageUrlCheck, onVideoPlayFunction, appendVvLinkToUrl } from "../../utils/utils";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import Loading from "../../Components/Loading/Loading";
import ContinueWatchingModel from "../../Components/Modals/ContinueWatchingModel";
import useScrollPosition from "../../Components/ScrollPosition/useScrollPosition";
import PlayNextEpisode from "../../Components/Modals/PlayNextEpisode";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import parse from "html-react-parser";
import TrailerModal from "../../Components/Modals/TrailerModal";
import RatingsAndReviewModal from "../../Components/Modals/RatingsAndReviewModal";
let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let videoPlaying = false;
const DetailsScreen = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
  const [isShareActive, setIsShareActive] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [videoPlay, setVideoPlay] = useState(false);
  const [isContinueWatchingModal, setIsContinueWatchingModal] = useState(false);
  const [continueWathchingVideoDetails, setContinueWatchingVideoDetails] = useState();
  const [watchDuration, setWatchDuration] = useState("");
  const [pageURL, setPageURL] = useState(0);
  const [showDetails, setShowDetails] = useState({});
  const [similarVideos, setSimilarVideos] = useState([]);
  const [playerToken, setPlayerToken] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [videoPlayer, setVideoPlayer] = useState("");
  const [watchlistStatus, setWatchlistStatus] = useState();
  const [watchWithoutAds, setWatchWithoutAds] = useState(false);
  const [selectedVideoDetails, setSelectedVideoDetails] = useState();
  const [logoutModal, setLogoutModal] = useState(false);
  const [categories, setCategories] = useState("");
  const [trailerPlaying, setTrailerPlaying] = useState(true);
  const [modalType, setModalType] = useState({ type: "logoutAll" });
  const [adUrl, setAdUrl] = useState("");
  const [initialVideoSubscriptions, setInitialVideoSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [skeleton, setSkeleton] = useState(false);
  const [subscribedUser, setSubscribeduser] = useState(false);
  const [browserPipMode, setBrowserPipMode] = useState(false);
  const [pipMode, setPipMode] = useState(false);
  const [nowPlaying, setNowPlaying] = useState("");
  const [episodes, setEpisodes] = useState();
  const [nextEpisodeModal, setNextEpisodeModal] = useState(false);
  const [isFreeVideo, setIsFreeVideo] = useState(false); // for inital free video checking for showing button name "subscribe" ,"watchNow" or "watch for free"
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [ratingReviewModal, setRatingReviewModal] = useState(false);
  const [userRatedCount, setUserRatedValue] = useState();
  const [directSubscribeState, setDirectSubscribeState] = useState({
    flag: false,
    data: null,
  });
  const [subscribeButton, setSubscribeButton] = useState();
  const [subtitleInfo, setSubTitleInfo] = useState();
  const [countinueWatchingVideoPlayedStatus, setCountinueWatchingVideoPlayedStatus] = useState(false);
  const [isTrailer, setIsTrailer] = useState(false)
  const [currentShowId, setCurrentShowId] = useState()
  const [error, setError] = useState();

  const position = useScrollPosition();
  const location = useLocation();
  let showId = location?.state?.showId;
  const type = location?.state?.type;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [videoType, setVideoType] = useState("video")

  const isTvod = showDetails?.payper_flag === 1 || showDetails?.rental_flag === 1;

  let shareRef = useRef(null);
  let reportRef = useRef(null);
  let shareIconRef = useRef(null);
  let shareTwoRef = useRef(null);
  let reportTwoRef = useRef(null);
  let shareIconTwoRef = useRef(null);
  let episodeCount = 0;
  let isLive = false

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const playerRef = useRef(null);

  useEffect(() => {
    if (projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT") {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    setAdUrl(null);
    if (showDetails) {
      setCurrentShowId(showDetails.show_id)
      if (Object.entries(showDetails).length > 0) {
        if (showDetails?.user_rated === true) {
          setUserRatedValue(showDetails?.user_rating);
        }
        if (showDetails?.type === "linear_event") {
          setVideoType("event")
        } else {
          setVideoType("video")
        }
        if (showDetails?.categories) {
          let categoryNames;
          showDetails?.categories?.map((item) => {
            categoryNames = categoryNames ? categoryNames + item?.category_name + "," : item?.category_name + ",";
          });
          setCategories(categoryNames);
        }
        if (showDetails?.watchlist_flag === 1) {
          setWatchlistStatus("added");
        } else {
          setWatchlistStatus("removed");
        }
        if (type === "CONTINUE_WATCHING" && countinueWatchingVideoPlayedStatus === false) {
          if (showDetails?.single_video === 0) {
            if (showDetails?.videos && showDetails?.videos[0]?.videos) {
              setEpisodes(showDetails?.videos[0]?.videos);

              let filteredVideo = showDetails?.videos.map((item) => {
                return item?.videos?.filter((videoItem) => videoItem?.video_id === location?.state?.videoId);
              });
              setSelectedVideoDetails(filteredVideo[0][0]);
              subscriptionCheckAndVideoPlay(filteredVideo[0][0]);
            } else {
              setEpisodes(showDetails?.videos);

              let filteredVideo = showDetails?.videos?.filter((item) => item?.video_id === location?.state?.videoId);
              setSelectedVideoDetails(filteredVideo[0]);
              subscriptionCheckAndVideoPlay(filteredVideo[0]);
            }
          } else if (showDetails?.single_video === 1) {
            setEpisodes(null);
            if (showDetails?.videos?.length > 0) {
              setSelectedVideoDetails(showDetails?.videos[0]);
              subscriptionCheckAndVideoPlay(showDetails?.videos[0]);
            }
          }
        } else {

          if (showDetails?.single_video === 1) {
            setSelectedVideoDetails(showDetails?.videos && showDetails?.videos[0]);
            setEpisodes(null);
          } else {
            if (showDetails?.videos && showDetails?.videos[0]?.videos && showDetails?.videos[0]?.videos[0]) {
              setSelectedVideoDetails(showDetails?.videos[0]?.videos[0]);
              setEpisodes(showDetails?.videos[0]?.videos);
            } else {
              setSelectedVideoDetails(showDetails?.videos && showDetails?.videos[0]);
              setEpisodes(showDetails?.videos);
            }
          }
        }
      }
    }
  }, [showDetails, type]);

  useEffect(() => {
    if (position === 0) {
      setPipMode(true);
    }
  }, [position]);

  useEffect(() => {
    window.scroll(0, 0);
    // if (accessToken && Object.keys(projectInfo).length > 0) {

    if (location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByVanityUrl(vanityUrl);
      } else {
        fetchShowDetails();
      }

      if (showId) {
        fetchSimilarVideos();
      }
    }
    // }
  }, [accessToken, projectInfo, location?.pathname]);


  useEffect(() => {
    if (selectedVideoDetails) {
      if (Object.entries(selectedVideoDetails).length > 0) {
        if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true") {
          setInitialVideoSubscriptions(selectedVideoDetails?.subscriptions);
          if (projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED === "true") {
            if (selectedVideoDetails?.subscriptions?.length > 0 || showDetails?.subscriptions?.length > 0) {
              let isSubscribedUser;
              if (showDetails?.subscriptions?.length > 0) {
                isSubscribedUser =
                  userSubscriptionData?.data?.length > 0
                    ? subscriptionCheck(userSubscriptionData?.data, showDetails?.subscriptions)
                    : false;
              } else {
                isSubscribedUser =
                  userSubscriptionData?.data?.length > 0
                    ? subscriptionCheck(userSubscriptionData?.data, selectedVideoDetails?.subscriptions)
                    : false;
              }

              if (isSubscribedUser === true) {
                setSubscribeduser(true);
                setSubscribeButton(false);
              } else {
                setSubscribeduser(false);

                if (selectedVideoDetails?.free_video === true) {
                  // for inital free video checking for showing button name "subscribe" ,"play Now"
                  setSubscribeButton(false);

                  setIsFreeVideo(true);
                } else {
                  setSubscribeButton(true);

                  setIsFreeVideo(false);
                }
              }
            } else {
              setSubscribeduser(true);
              setSubscribeButton(false);
            }
          } else {
            setSubscribeduser(true);
            setSubscribeButton(false);
          }
        } else if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "false") {
          setSubscribeButton(false);
          if (userSubscriptionData?.login_needed === false) {
            setIsFreeVideo(true);
          } else {
            setIsFreeVideo(false);
          }
          setInitialVideoSubscriptions(selectedVideoDetails?.subscriptions);
        }

        if (showDetails) {
          var updateDuration = selectedVideoDetails?.watched_duration;
          setWatchDuration(updateDuration);
        }
      }
    }
  }, [selectedVideoDetails]);

  useEffect(() => {
    setVideoPlayer(null);
    if (videoUrl) {
      const videoJsOptions = {
        autoplay: videoPlay,
        controls: true,
        responsive: true,
        fluid: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${videoUrl}`,
            type: "application/x-mpegURL",
          },
        ],

        // poster:require("../../../images/thumb.png")
      };
      setLoading(false);

      setSkeleton(false);
      setVideoPlayer(
        <VideoJS
          options={videoJsOptions}
          onReady={handlePlayerReady}
          adUrl={adUrl ? adUrl : null}
          subtitles={subtitleInfo}
        />
      );
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [videoUrl]);

  useEffect(() => {
    setPageURL(window.location.href);
    fetchUserSubscriptionDetails();
  }, []);

  useEffect(() => {
    let handleOutClick = (e) => {
      if (
        !shareIconRef?.current?.contains(e.target) &&
        !shareRef?.current?.contains(e.target) &&
        !shareIconTwoRef?.current?.contains(e.target) &&
        !shareTwoRef?.current?.contains(e.target)
      ) {
        setIsShareActive(false);
      }
      if (!reportRef?.current?.contains(e.target) && !reportTwoRef?.current?.contains(e.target)) {
        setIsReport(false);
      }
    };
    window.addEventListener("click", handleOutClick);
  }, [shareRef, reportRef, shareTwoRef, reportTwoRef]);

  const fetchUserSubscriptionDetails = async () => {
    const userSubResponse = await getUserSubscription(appInfo);
    if (userSubResponse?.status === 200) {
      dispatch(
        getUserSubscriptionData({
          userSubscription: userSubResponse?.data,
        })
      );
    }
  };

  const fetchShowDetails = async () => {
    try {
      setLoading(true);
      const showDetailsResponse = await service.getShowDetails(appInfo, showId);
      if (showDetailsResponse?.status === 200) {
        setShowDetails(showDetailsResponse?.data?.data);
        setLoading(false);
        setError(false);
      }
    } catch (err) {
      setError(true);
      setLoading(false);
    }
  };

  const fetchShowDetailsByVanityUrl = async (vanityUrl) => {
    try {
      setLoading(true);
      const showDetailsResponse = await service.getShowDetails(appInfo, vanityUrl);
      if (showDetailsResponse?.status === 200) {
        setShowDetails(showDetailsResponse?.data?.data);
        setLoading(false);
        if (!showId) {
          fetchSimilarVideos(showDetailsResponse?.data?.data?.show_id);
        }
      }
      else{
        setError(true);  
      }
      
    } catch (err) {
      setError(true);
      setLoading(false);
    }
  };

  const fetchSimilarVideos = async (sid) => {
    let id = showId ? showId : sid;
    const similarVideosResponse = await service.getSimilarVideos(appInfo, id);
    if (similarVideosResponse?.status === 200) {
      setSimilarVideos(similarVideosResponse?.data?.data);
    }
  };

  const fetchPlayerToken = async (isTrailer, videoId) => {
    const playerTokenResponse = await getPlayerToken(appInfo, videoId);
    if (playerTokenResponse?.status === 200) {
      setPlayerToken(playerTokenResponse?.data?.data);
      if (isTrailer) {
        let arr = showDetails?.teaser?.split("/").reverse();
        setVideoUrl(
          "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
          arr[1] +
          "&token=" +
          playerTokenResponse?.data?.data +
          "&type=trailer" +
          "&pubid=" +
          projectInfo?.projectConfig?.pubid
        );
      }
      return playerTokenResponse?.data?.data;
    }
  };

  const updateWatchlist = async (showId, flag) => {
    try {
      const response = await updateWatchlistData(appInfo, currentShowId, flag);

      if (response?.status === 200) {
        if (flag === 1) {
          toast.success("Added to mylist", {
            position: "bottom-center",
            toastId: "success1",
          });
          setWatchlistStatus("added");
        } else {
          toast.success("Removed from mylist", {
            position: "bottom-center",
          });
          setWatchlistStatus("removed");
        }
      }
    } catch (err) {
    }
  };
  const addToWatchlist = () => {
    if (user) {
      updateWatchlist(showId, 1);
    } else {
      navigate("/login", { state: { path: location?.pathname, showId: showId } });
    }
  };
  const removeFromWatchlist = () => {
    updateWatchlist(showId, 0);
  };

  const subscriptionCheck = (userSub, videoSub) => {
    const hasMatch = userSub.some((user) => videoSub.some((video) => user.sub_id === video.subscription_id));
    return hasMatch;
  };

  const playVideo = async (videoDetails) => {
    let vanityUrl = location?.pathname.split("/")[2];
    navigate(`/videos/${videoDetails?.vanity_url}`, { state: { videoId: videoDetails?.video_id,videoDetails ,showDetails} })
  };

  const redirectToLogin = () => {
    dispatch(
      getUser({
        user: null,
      })
    );
    localStorage.removeItem("userId");
    tokenAuthenticate();
    navigate("/login", {
      state: { path: location?.pathname, showId: showId },
    });
  };

  const tokenAuthenticate = async () => {
    const response = await authenticate2(appInfo);
    if (response?.status === 200) {
      dispatch(
        getAccessToken({
          accessToken: response?.data?.token,
        })
      );
    }
  };

  const handleSubscribe = (data) => {
    if (user) {
      window.open(appendVvLinkToUrl("https://redeemtv.com/donate"), "_self")
    } else {
      navigate("/login", {
        state: { path: location?.pathname, showId: showId },
      });
    }
  };

  const subscriptionCheckAndVideoPlay = async (videoDetails, directSubscribe, directSubscribeData) => {
    if (user) {
      await fetchUserSubscriptionDetails()
      if (directSubscribe) {
        setDirectSubscribeState({ flag: true, data: directSubscribeData });
      } else {
        setDirectSubscribeState({ flag: false, data: null });
      }
      if (projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED === "true") {
        if (userSubscriptionData?.forcibleLogout === true) {
          setLogoutModal(true);
          setModalType({
            type: "logoutAll",
            heading: "You’ve reached the maximum Device limit.Do you want to logout from all devices",
          });
        } else if (userSubscriptionData?.session_expired === true) {
          setModalType({ type: "redirect" });
          setLogoutModal(true);
          setTimeout(() => {
            redirectToLogin();
          }, 1000);
        } else {
          // const videoSubscriptionData = await fetchVideoSubscription(
          //   videoDetails?.video_id
          // );
          // setVideoSubscriptions(videoSubscriptionData);
          if (videoDetails?.subscriptions?.length > 0 || showDetails?.subscriptions?.length > 0) {
            let isSubscribedUser;
            if (showDetails?.subscriptions?.length > 0) {
              isSubscribedUser =
                userSubscriptionData?.data?.length > 0
                  ? subscriptionCheck(userSubscriptionData?.data, showDetails?.subscriptions)
                  : false;
            } else {
              isSubscribedUser =
                userSubscriptionData?.data?.length > 0
                  ? subscriptionCheck(userSubscriptionData?.data, videoDetails?.subscriptions)
                  : false;
            }
            if (isSubscribedUser === true) {
              if (videoDetails?.watched_duration) {
                setWatchDuration(videoDetails?.watched_duration);
                setIsContinueWatchingModal(true);
              } else {
                playVideo(videoDetails);
              }
            } else {
              let vanityUrl = location?.pathname.split("/")[2];
              if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
                localStorage.setItem("vanityUrl", vanityUrl);
              } else {
                localStorage.setItem("showId", showId);
              }
              if (videoDetails?.free_video === true) {
                if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
                  // setAdUrl(convertAdUrl(selectedVideoDetails, showDetails, appInfo));

                  setWatchWithoutAds(true);
                } else {
                  if (videoDetails?.watched_duration) {
                    setWatchDuration(videoDetails?.watched_duration);
                    setIsContinueWatchingModal(true);
                  } else {
                    playVideo(videoDetails);
                  }
                }
              } else {
                if (directSubscribe === true) {
                  handleSubscribe(directSubscribeData);
                } else {
                  // navigate("/subscription", {
                  //   state: { subscriptionList: videoSubscriptionData },
                  // });
                  // navigate("/subscription", {
                  //   state: { videoId: videoDetails?.video_id },
                  // });
                  window.open(appendVvLinkToUrl("https://redeemtv.com/donate"), "_self")
                }
              }
            }
          } else {
            if (showDetails) {
              if (videoDetails?.watched_duration) {
                setWatchDuration(videoDetails?.watched_duration);
                setIsContinueWatchingModal(true);
              } else {
                if (userSubscriptionData?.data?.length > 0 && videoDetails?.subscriptions?.length === 0) {
                  playVideo(videoDetails);
                } else {
                  // if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
                  //   setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo,isLive));
                  // }
                  //needed in video details page
                  playVideo(videoDetails);
                }
              }
            }
            // playVideo(videoDetails);
          }
        }
      } else {
        if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
          if (videoDetails?.watched_duration) {
            // setWatchDuration(videoDetails?.watched_duration);
            // setIsContinueWatchingModal(true);
            playVideo(videoDetails);

          } else {
            // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo,isLive));
            playVideo(videoDetails);
          }
        } else {
          playVideo(videoDetails);
        }
      }
    } else {
      navigate("/login", {
        state: { path: location?.pathname, showId: showId },
      });
    }
  };

  const watchVideoHandler = async (videoDetails, directSubscribe, directSubscribeData) => {
      playVideo(videoDetails);
    setSelectedVideoDetails({ ...videoDetails, showId: showId });
    
    // if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true") {
    //   subscriptionCheckAndVideoPlay(videoDetails, directSubscribe, directSubscribeData);
    // } else {
    //   if (userSubscriptionData?.login_needed === false) {
    //     if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
    //       setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
    //     }
    //     playVideo(videoDetails);
    //   } else if (userSubscriptionData?.login_needed === true) {
    //     setModalType({ type: "videoWatchLimitExpired" });
    //     setLogoutModal(true);
    //   } else {
    //     subscriptionCheckAndVideoPlay(videoDetails, directSubscribe, directSubscribeData);
    //   }
    // }
       
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    if (!trailerPlaying) {
      player.on("play", () => {
        let event = videoStarted === true ? "POP09" : "POP02";
        videoStarted = true;
        videoPlaying = true;
        updateVideoAnalytics(event, player.currentTime());
      });
      player.on("loadedmetadata", () => {
        player.pause();
        if (watchDuration > 0) {
          player.currentTime(watchDuration.toString());
          player.play();
          videoPlaying = true;
        } else {
          player.play();
          videoPlaying = true;
        }
      });
      player.on("timeupdate", function (e) {
        let event = "POP03";
        videoPlaying = true;
        var hasPlayedTime = player.currentTime();
        var intPlayedTime = parseInt(hasPlayedTime, 10);
        var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
        if (isSixty && debounce) {
          debounce = false;
          prevTime = intPlayedTime;
          updateVideoAnalytics(event, player.currentTime());
        } else {
          if (debounce == false && prevTime != intPlayedTime) {
            debounce = true;
          }
        }
      });

      player.on("pause", () => {
        let event = "POP04";
        videoPlaying = true;
        updateVideoAnalytics(event, player.currentTime());
      });
      player.on("ended", () => {
        let event = "POP05";
        videoPlaying = false;
        episodeCount = findIndex() + 1;

        updateVideoAnalytics(event, player.currentTime());
        if (episodes[episodeCount]) {
          setNextEpisodeModal(true);
        }
      });
      player.on("dispose", () => {
        videoPlaying = false;
        videoStarted = false;
        player.pause();
      });
    } else {
      player.on("timeupdate", () => {
        videoPlaying = true;
      });
      player.on("dispose", () => {
        videoPlaying = false;
      });
    }
  };

  const updateVideoAnalytics = async (event, time) => {
    const isLive = "0";
    const updateResponse = await onVideoPlayFunction(
      appInfo,
      selectedVideoDetails,
      event,
      time,
      isLive,
      categories,
      showDetails?.show_id
    );
  };

  const findIndex = () => {
    let elementIndex = null;
    if (episodes) {
      episodes?.filter((filteringItem, index) => {
        if (filteringItem?.video_id === selectedVideoDetails?.video_id) {
          elementIndex = index;
        }
      });
    }
    return elementIndex;
  };

  window.addEventListener("enterpictureinpicture", () => {
    setBrowserPipMode(true);
  });

  window.addEventListener("leavepictureinpicture", () => {
    setBrowserPipMode(false);
  });

  if (error) {
    navigate("/404");
  }
  if (loading) {
    return <Loading />;
  }
  return (
    <div className="detailsScreen">
      {watchWithoutAds && (
        <WatchWithoutAdsModal
          setWatchWithoutAds={setWatchWithoutAds}
          showDetails={showDetails}
          appInfo={appInfo}
          setAdUrl={setAdUrl}
          videoDetails={selectedVideoDetails}
          playVideo={playVideo}
          setIsContinueWatching={setIsContinueWatchingModal}
          showDuration={watchDuration}
          videoPlay={setVideoPlay}
          directSubscribeState={directSubscribeState}
          handleSubscribe={handleSubscribe}
          islive={isLive}

        />
      )}
      {nextEpisodeModal && (
        <PlayNextEpisode
          episodes={episodes}
          findIndex={findIndex}
          watchVideoHandler={watchVideoHandler}
          setNextEpisodeModal={setNextEpisodeModal}
        />
      )}

      {ratingReviewModal && (
        <RatingsAndReviewModal
          showName={showDetails?.show_name}
          director={showDetails?.director}
          year={showDetails?.year}
          showId={showDetails?.show_id}
          setRatingReviewModal={setRatingReviewModal}
          setUserRatedValue={setUserRatedValue}
        />
      )}

      {/* {isContinueWatchingModal && (
        <ContinueWatchingModel
          setIsContinueWatchingModal={setIsContinueWatchingModal}
          videoDetails={selectedVideoDetails}
          playVideo={playVideo}
          // playContinueVideo={playContinueVideo}
          watchDuration={watchDuration}
          showDetails={showDetails}
          appInfo={appInfo}
          setAdUrl={setAdUrl}
          islive={isLive}
        />
      )} */}
      {logoutModal && (
        <LogoutAllModal
          showId={showId}
          appInfo={appInfo}
          setLogoutModal={setLogoutModal}
          modalType={modalType}
          videoDetails={selectedVideoDetails}
          subscriptionCheckAndVideoPlay={subscriptionCheckAndVideoPlay}
        />
      )}
      {
        isTrailer &&
        <TrailerModal appInfo={appInfo} teaser={showDetails?.teaser} showName={showDetails?.show_name} setIsTrailer={setIsTrailer} />
      }
      <div className="wrapper">
        <div className="bgImageContainer">
          {imageUrlCheck(showDetails?.logo_thumb) ? (
            <img
              src={`${showDetails?.logo_thumb}`}
              alt="Background"
            />
          ) : (
            <img
              src={
                `${process.env.REACT_APP_IMAGE_URL}${showDetails?.logo_thumb}`
              }
              alt="Background"
            />
          )}
          <div className="gradient"></div>
        </div>
        {/* {
          skeleton&&
            imageUrlCheck(showDetails?.logo_thumb)?(
              <img
            src={
              `${showDetails?.logo_thumb}`
            }
            alt="Background"
          />
            ):(

              <img
                src={
                    `${process.env.REACT_APP_IMAGE_URL}${showDetails?.logo_thumb}`
                }
                alt="Background"
              />
            )
        } */}
        {videoPlayer && (
          <div
            className={
              pipMode === false
                ? "videoContainer"
                : position > 700 && browserPipMode === false && videoPlaying === true
                  ? "videoContainer heightIncrease"
                  : "videoContainer"
            }
          >
            <div
              className={
                position > 700 && browserPipMode === false && videoPlaying === true && pipMode === true
                  ? "player pipMode"
                  : "player"
              }
            >
              <div className="gradientTop"></div>
              <div className="closeIcon" onClick={() => setPipMode(false)}>
                <Closeicon />
              </div>
              {/* {
              videoPlaying&& */}
              {/* <div className="nowPlaying">
                <h1>Now Playing : {nowPlaying}</h1>
              </div> */}
              {/* // } */}
              {/* {videoPlayer && videoPlayer} */}
            </div>
          </div>
        )}
        <div className="details">
          <div className="leftContainer">
            <div className="showCardDetails">
              <div className="imageContainer">
                {imageUrlCheck(thumbnailOrientation === "PORTRAIT" ? showDetails?.logo : showDetails?.logo_thumb) ? (
                  <img
                    src={thumbnailOrientation === "PORTRAIT" ? `${showDetails?.logo}` : `${showDetails?.logo_thumb}`}
                    alt="Background"
                  />
                ) : (
                  <img
                    src={
                      thumbnailOrientation === "PORTRAIT"
                        ? `${process.env.REACT_APP_IMAGE_URL}${showDetails?.logo}`
                        : `${process.env.REACT_APP_IMAGE_URL}${showDetails?.logo_thumb}`
                    }
                    alt="Background"
                  />
                )}
              </div>

              {
                showDetails?.hide_play_button !== true && (
                  <div className="watchNow" onClick={() => {
                    if (isTvod && user) {
                      showDetails?.checkout_link
                      ? window.open(showDetails.checkout_link, "_self")
                      : watchVideoHandler(selectedVideoDetails);
                    } else if (isTvod && !user) {
                      navigate('/login', { state: { path: location?.pathname, showId } });
                    } else {
                      watchVideoHandler(selectedVideoDetails);
                    }
                  }}>
                    <button className={`${isTvod && showDetails.checkout_link ? "tvod" : ""}`}>
                      {isTvod ? showDetails?.button_text : subscribeButton ? "DONATE" : isFreeVideo ? "Watch now for Free" : "Watch Now"}
                    </button>
                  </div>
                )
              }
              {
                showDetails?.teaser_flag === 1 && showDetails?.teaser &&
                <div className="trailer" onClick={() => setIsTrailer(true)}>
                  <button>Trailer</button>
                </div>
              }
              {watchlistStatus === "added" ? (
                <div className="addtoList" onClick={() => removeFromWatchlist()}>
                  <button>Remove From mylist</button>
                </div>
              ) : (
                <div className="addtoList" onClick={() => addToWatchlist()}>
                  <button>Add to My List</button>
                </div>
              )}
              <div className="buttons">
                <div className="buttonContainerOne">
                  <button
                    className="share"
                    onClick={() => {
                      setIsShareActive(!isShareActive);
                      setIsReport(false);
                    }}
                    ref={shareIconRef}
                  >
                    Share
                  </button>
                  <div className={isShareActive ? "active shareContainer" : "shareContainer"} ref={shareRef}>
                    <div className="facebookContainer" onClick={() => setIsShareActive(false)}>
                      {/* <div className="left"> */}
                      <FacebookShareButton url={pageURL} quote={"Share"} className="facebook">
                        Facebook
                        <div className="icon">
                          <FacebookIcon />
                        </div>
                      </FacebookShareButton>
                      {/* </div> */}
                      {/* <div className="right">
                        <FacebookIcon />
                      </div> */}
                    </div>
                    <div className="twitterContainer" onClick={() => setIsShareActive(false)}>
                      <TwitterShareButton url={pageURL} className="twitter">
                        Twitter
                        <div className="icon">
                          <TwitterIcon />
                        </div>
                      </TwitterShareButton>
                    </div>
                  </div>
                </div>
                <div className="buttonContainerTwo">
                  <button
                    className="more"
                    onClick={() => {
                      setIsReport(!isReport);
                      setIsShareActive(false);
                    }}
                    ref={reportRef}
                  >
                    {isReport ? <Closeicon /> : "..."}
                  </button>
                  {isReport ? (
                    <div
                      className={isReport ? "reportProblemContainer active" : "reportProblemContainer"}
                      onClick={() => navigate("/contact-support")}
                    >
                      <span>Report a problem</span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="rightContainer">
            <div className="showMetadata">
              <h1 className="name">{showDetails?.show_name}</h1>

              <div className={"data"}>
                <span className="year">{showDetails?.year}</span>
                <span className={`duration ${showDetails?.year && "showDot"}`}>{showDetails?.duration_text}</span>
                {
                  showDetails?.rating &&
                  <span className="certificate">{showDetails?.rating}</span>
                }
                {userRatedCount ? (
                  <div className="userRatings">
                    <div className={userRatedCount >= 1 ? "active star" : "no-active star"}>
                      <StarIcon />
                    </div>
                    <div className={userRatedCount >= 2 ? "active star" : "no-active star"}>
                      <StarIcon />
                    </div>
                    <div className={userRatedCount >= 3 ? "active star" : "no-active star"}>
                      <StarIcon />
                    </div>
                    <div className={userRatedCount >= 4 ? "active star" : "no-active star"}>
                      <StarIcon />
                    </div>
                    <div className={userRatedCount >= 5 ? "active star" : "no-active star"}>
                      <StarIcon />
                    </div>
                  </div>
                ) : (
                  <div className="addRating" title="Rate and Review" onClick={() => setRatingReviewModal(true)}>
                    <AddRatings />
                  </div>
                )
                }
              </div>
              <div className="genres">
                {showDetails?.categories?.map((item, index) => (
                  <span key={index}>{item?.category_name}</span>
                ))}
              </div>

              {
                showDetails?.hide_play_button !== true && (
                    <div className="watchNow" onClick={() => {
                      if (isTvod && user) {
                        showDetails?.checkout_link
                          ? window.open(showDetails.checkout_link, "_self")
                          : watchVideoHandler(selectedVideoDetails);
                      } else if (isTvod && !user) {
                        navigate('/login', { state: { path: location?.pathname, showId } });
                      } else {
                        watchVideoHandler(selectedVideoDetails);
                      }
                    }}>
                      <button className={`${isTvod && showDetails.checkout_link ? "tvod" : ""}`}>
                        {isTvod ? showDetails?.button_text : subscribeButton ? "DONATE" : isFreeVideo ? "Watch now for Free" : "Watch Now"}
                      </button>
                    </div>
                  )
                }
              {
                showDetails?.teaser_flag === 1 && showDetails?.teaser &&
                <div className="trailer" onClick={() => setIsTrailer(true)}>
                  <button>Trailer</button>
                </div>
              }
              {watchlistStatus === "added" ? (
                <div className="addtoList" onClick={() => removeFromWatchlist()}>
                  <button>Remove From mylist</button>
                </div>
              ) : (
                <div className="addtoList" onClick={() => addToWatchlist()}>
                  <button>Add to My List</button>
                </div>
              )}

              <div className="buttons">
                <div className="buttonContainerOne">
                  <button
                    className="share"
                    onClick={() => {
                      setIsShareActive(!isShareActive);
                      setIsReport(false);
                    }}
                    ref={shareIconTwoRef}
                  >
                    Share
                  </button>
                  <div className={isShareActive ? "active shareContainer" : "shareContainer"} ref={shareTwoRef}>
                    <div className="facebookContainer" onClick={() => setIsShareActive(false)}>
                      {/* <div className="left"> */}
                      <FacebookShareButton url={pageURL} quote={"Share"} className="facebook">
                        Facebook
                        <div className="icon">
                          <FacebookIcon />
                        </div>
                      </FacebookShareButton>
                      {/* </div> */}
                      {/* <div className="right">
                        <FacebookIcon />
                      </div> */}
                    </div>
                    <div className="twitterContainer" onClick={() => setIsShareActive(false)}>
                      <TwitterShareButton url={pageURL} className="twitter">
                        Twitter
                        <div className="icon">
                          <TwitterIcon />
                        </div>
                      </TwitterShareButton>
                    </div>
                  </div>
                </div>
                <div className="buttonContainerTwo">
                  <button
                    className="more"
                    onClick={() => {
                      setIsReport(!isReport);
                      setIsShareActive(false);
                    }}
                    ref={reportTwoRef}
                  >
                    {isReport ? <Closeicon /> : "..."}
                  </button>
                  {isReport ? (
                    <div
                      className={isReport ? "reportProblemContainer active" : "reportProblemContainer"}
                      onClick={() => navigate("/contact-support")}
                    >
                      <span>Report a problem</span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="description">{parse(showDetails?.synopsis?.split("\n")?.join("<br>") || showDetails?.video_description?.split("\n")?.join("<br>"))}</p>
              <div className="info">
                {showDetails?.show_cast && (
                  <div className="starring">
                    <div className="left">
                      <h6>Starring</h6>
                    </div>
                    <div className="right">
                      <ul className="names">
                        <li>{showDetails?.show_cast}</li>
                      </ul>
                    </div>
                  </div>
                )}
                {showDetails?.director && (
                  <div className="director">
                    <div className="left">
                      <h6>Directed by</h6>
                    </div>
                    <div className="right">
                      <h6>{showDetails?.director}</h6>
                    </div>
                  </div>
                )}
              </div>
              {!subscribedUser || selectedVideoDetails?.free_video === true ? (
                showDetails?.subscriptions?.length > 0 || selectedVideoDetails?.free_video === true ? (
                  <div className="subscriptions">
                    {showDetails?.subscriptions?.map((item, index) => (
                      <div className="items" key={index} onClick={() => handleSubscribe(item)}>
                        {item?.subscription_text}
                      </div>
                    ))}
                    {showDetails?.single_video === 1 && selectedVideoDetails?.free_video === true && (
                      <div className="items free" onClick={() => watchVideoHandler(selectedVideoDetails)}>
                        Free
                      </div>
                    )}
                  </div>
                ) : null
              ) : null}
            </div>
            {showDetails?.single_video === 0 && showDetails?.videos?.length > 1 && showDetails?.videos[0]?.videos && (
              <ShowsRow
                season={true}
                data={showDetails?.videos}
                metaData={false}
                watchVideoHandler={watchVideoHandler}
                type="episodes"
                thumbnailOrientation={thumbnailOrientation}

              />
            )}
            {showDetails?.single_video !== 1 && showDetails?.videos?.length === 1 && showDetails?.videos[0]?.season && (
              <ShowsRow
                season={false}
                data={showDetails?.videos[0]?.videos}
                title={"Episodes"}
                metaData={false}
                watchVideoHandler={watchVideoHandler}
                type="episodes"
                thumbnailOrientation={thumbnailOrientation}
              />
            )}
            {showDetails?.single_video === 0 && !showDetails?.videos[0]?.videos && (
              <ShowsRow
                season={false}
                data={showDetails?.videos}
                title={"Episodes"}
                metaData={false}
                watchVideoHandler={watchVideoHandler}
                type="episodes"
                thumbnailOrientation={thumbnailOrientation}
              />
            )}
            {similarVideos?.length > 0 && (
              <ShowsRow
                season={false}
                data={similarVideos}
                title="You May Also Like"
                metaData={true}
                setVideoPlayer={setVideoPlayer}
                similarVideos={true}
                thumbnailOrientation={thumbnailOrientation}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsScreen;
